import { Fragment } from "react";

// Shows the plain text the client typed in the admin form:
//   **text**        -> bold
//   blank line      -> new paragraph (same look as the old <br /><br />)
//   single new line -> line break
// It builds React elements instead of injecting HTML, so nothing a client
// types can ever run as code on the site.
function Inline({ text }) {
  const parts = text.split(/\*\*([\s\S]+?)\*\*/g); // odd positions are the bold bits
  return parts.map((part, i) => {
    const content = part.split("\n").map((line, j) => (
      <Fragment key={j}>
        {j > 0 && <br />}
        {line}
      </Fragment>
    ));
    return i % 2 === 1 ? <strong key={i}>{content}</strong> : <Fragment key={i}>{content}</Fragment>;
  });
}

export const withEllipsis = (text) =>
  text ? `${String(text).replace(/[\s.…]+$/, "")}\u00A0.\u00A0.\u00A0.` : text;

const FormattedText = ({ text }) => {
  if (!text) return null;
  const paragraphs = String(text).replace(/\r\n/g, "\n").trim().split(/\n\s*\n/);
  return (
    <>
      {paragraphs.map((para, i) => (
        <Fragment key={i}>
          {i > 0 && (
            <>
              <br />
              <br />
            </>
          )}
          <Inline text={para} />
        </Fragment>
      ))}
    </>
  );
};

export default FormattedText;